export const ASYNC_FETCH = 'ASYNC_FETCH_CLIST';
export const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS_CLIST';
export const ASYNC_FETCH_FAILURE = 'ASYNC_FETCH_FAILURE_CLIST';
export const ASYNC_FETCH_INVALIDATE = 'ASYNC_FETCH_INVALIDATE_CLIST';
export const COUNTRY_LIST_DATA = 'COUNTRY_LIST_DATA';
/**
 * action types
 * @type {string}
 */
